<template>
  <div class="app-container">
    <div class="tb" style="height: 100%">
      <div class="main tb">
        <div class="lr between">
          <div style="display: flex;justify-content: flex-start;">
            <el-input v-model="table.query.keyWord" placeholder="请输入关键字查询" clearable
                      suffix-icon="el-icon-search" @change="search(true)" style="width: 217px;"/>
          </div>
          <div style="display: flex;justify-content: flex-end;">
            <el-button type="primary" size="small" @click="openDialog(null, false)"
                       icon="el-icon-plus">新增
            </el-button>
          </div>
        </div>
        <div class="main" style="margin-top: 20px;">
          <el-table :data="table.data" height="600px" border
                    :header-cell-style="{background:'#fafafa',color:'#000000'}" v-loading="tableLoading">
            <el-table-column show-overflow-tooltip fixed="left" label="序号" type="index" width="55"
                             align="center"/>
            <el-table-column show-overflow-tooltip label="房间" align="center"
                             prop="roomName"></el-table-column>
            <el-table-column show-overflow-tooltip label="月租金" align="center"
                             prop="rent"></el-table-column>
            <el-table-column show-overflow-tooltip label="实收租金" align="center"
                             prop="rent">
              <template slot-scope="scope">
                <span v-if="scope.row.payType == 0">{{scope.row.rent}}</span>
                <span v-if="scope.row.payType == 1">{{Math.ceil(scope.row.rent) * 3}}</span>
                <span v-if="scope.row.payType == 2">{{Math.ceil(scope.row.rent) * 6}}</span>
                <span v-if="scope.row.payType == 3">{{Math.ceil(scope.row.rent) * 12}}</span>
                <span v-if="scope.row.payType == 4">{{Math.ceil(scope.row.rent) * 2}}</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip label="状态" align="center"
                             prop="state">
              <template slot-scope="scope">
                <span v-if="scope.row.state == 0">未收租</span>
                <span v-if="scope.row.state == 1">已收租</span>
                <span v-if="scope.row.state == 2">退租</span>
                <span v-if="scope.row.state == 3">未生效</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip label="应收租日期" align="center"
                             prop="needRentDate"></el-table-column>
            <el-table-column show-overflow-tooltip label="实际收租日期" align="center"
                             prop="actualRentDate"></el-table-column>
            <el-table-column show-overflow-tooltip label="备注" align="center"
                             prop="description"></el-table-column>
            <el-table-column show-overflow-tooltip label="操作" width="210" align="center" v-if="showButton">
              <template slot-scope="scope">
                <el-button type="text" :loading="confirmLoading" @click="confirmRecord(scope.row, 1)" v-if="scope.row.state == 0" :disabled="scope.row.adminId != userInfo.id">收租</el-button>
                <el-button type="text" @click="openDialog(scope.row, true)">编辑</el-button>
                <el-button type="text" style="color: #ff4949;" @click="deleteData(scope.row.id)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="lr end" style="margin-top: 20px;">
          <el-pagination :total="table.total" :page-size="table.query.size" :current-page="table.query.page"
                         layout="total, prev, pager, next" @current-change="currentPageChange"/>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="collectRecordDialog.visible" :close-on-click-modal="false" width="40%"
               :title="!isEdit ? '新增收租记录' : '编辑收租记录'">
      <el-form ref="collectRecordForm" label-position="right" label-width="120px" :model="collectRecordDialog.formData"
               :rules="rules">
        <el-form-item label="主题：" prop="title">
          <el-input placeholder="请输入主题" v-model="collectRecordDialog.formData.title" clearable/>
        </el-form-item>
        <el-form-item label="出租记录：" prop="rentRecordId">
          <el-select filterable  v-model="collectRecordDialog.formData.rentRecordId" placeholder="请选择出租记录" clearable style="width: 100%;">
            <el-option v-for="item in rentRecords" :key="item.id" :value="item.id"
                       :label="item.startDate + '至' + item.endDate"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="租金：" prop="rent">
          <el-input-number :precision="2" :step="0.1" :min="0" style="width: 100%" v-model="collectRecordDialog.formData.rent"
                           clearable/>
        </el-form-item>
        <el-form-item label="状态：" prop="state">
          <el-select filterable  v-model="collectRecordDialog.formData.state" placeholder="请选择状态" clearable style="width: 100%;">
            <el-option v-for="item in states" :key="item.id" :value="item.id"
                       :label="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="应收租日期：" prop="needRentDate">
          <el-date-picker
            v-model="collectRecordDialog.formData.needRentDate"
            type="date"
            placeholder="请选择应收租日期"
            value-format="yyyy-MM-dd"
            style="width: 100%;">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="实际收租日期：" prop="actualRentDate">
          <el-date-picker
            v-model="collectRecordDialog.formData.actualRentDate"
            type="date"
            placeholder="请选择实际收租日期"
            value-format="yyyy-MM-dd"
            style="width: 100%;">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="备注：" prop="description">
          <el-input type="textarea" :rows="3" placeholder="请输入备注" v-model="collectRecordDialog.formData.description"></el-input>
        </el-form-item>
      </el-form>
      <div class="dialog-btn">
        <el-button @click="collectRecordDialog.visible = false">取消</el-button>
        <el-button type="primary" @click="saveOrUpdateData" :loading="loading">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>

import {getPageList, deleteData, saveOrUpdateData, confirmRecord} from "@/api/collectRecord";

export default {
  props: {
    rentRecords: {
      type:Array,
      default: () => []
    },
    rentRecordId: {
      type: Number,
      default: 0
    },
    roomId: {
      type: Number,
      default: 0
    },
    showButton: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      table: {
        query: {
          page: 1,
          size: 10,
          keyWord: '',
          rentRecordId: '',
          roomId: ''
        },
        total: 0,
        data: []
      },
      collectRecordDialog: {
        formData: {
          rentRecordId: '',
          rent: 0,
          state: 0,
          needRentDate: '',
          actualRentDate: '',
          description: ''
        },
        visible: false
      },
      rules: {
        rentRecordId: [
          {trigger: 'change', required: true, message: '请选择出租记录'}
        ],
        title: [
          {trigger: 'change', required: true, message: '请输入主题'}
        ],
        rent: [
          {trigger: 'change', required: true, message: '请输入租金'}
        ],
        state: [
          {trigger: 'blur', required: true, message: '请选择状态'}
        ],
        needRentDate: [
          {trigger: 'blur', required: true, message: '请选择应收租日期'}
        ]
      },
      loading: false,
      confirmLoading: false,
      tableLoading: false,
      isEdit: false,
      states: [
        {
          id: 0,
          name: '未收租'
        },
        {
          id: 1,
          name: '已收租'
        },
        {
          id: 2,
          name: '退租'
        }
      ],
      userInfo: {}
    }
  },
  mounted() {
    this.search(true)
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
  },
  methods: {
    // 搜索框查询
    search(flag) {
      this.tableLoading = true
      if (flag) {
        this.table.query.page = 1
        this.table.query.keyWord = ''
        this.table.query.rentRecordId = ''
        this.table.query.roomId = this.roomId
        this.table.query.rentRecordId = this.rentRecordId
      }
      const params = {
        current: this.table.query.page,
        size: this.table.query.size,
        keyWord: this.table.query.keyWord,
        rentRecordId: this.table.query.rentRecordId,
        roomId: this.table.query.roomId,
        fromCooperateManage: !this.showButton
      }
      getPageList(params).then(response => {
        if (response.code == 200) {
          // 查询成功
          this.table.data = response.data
          this.table.total = response.count
        } else {
          // 查询失败
          this.$message.error('查询失败!')
        }
        this.tableLoading = false
      })
    },
    // 修改收租记录
    saveOrUpdateData() {
      this.loading = true
      this.$refs['collectRecordForm'].validate(async (valid) => {
        if (valid) {
          saveOrUpdateData(this.collectRecordDialog.formData).then(response => {
            if (response.code == 200) {
              // 操作成功
              this.$message.success('操作成功!')
              this.collectRecordDialog.visible = false
              this.search(false)
            } else {
              // 操作失败
              this.$message.error('操作失败!')
            }
            this.loading = false
          })
        } else {
          this.loading = false
        }
      })
    },
    // 打开弹窗
    openDialog(data, isEdit) {
      this.isEdit = isEdit
      if (!isEdit) {
        // 重置数据
        this.collectRecordDialog.formData = {
          rentRecordId: '',
          rent: 0,
          state: 0,
          needRentDate: '',
          actualRentDate: '',
          description: ''
        }
      } else {
        this.collectRecordDialog.formData = JSON.parse(JSON.stringify(data))
      }
      this.collectRecordDialog.visible = true
      // 清空验证信息
      this.$nextTick(() => {
        this.$refs.collectRecordForm.clearValidate()
      })
    },
    // 页码变更
    currentPageChange(page) {
      this.table.query.page = page
      this.search(false)
    },
    // 删除收租记录
    deleteData(id) {
      this.$confirm('此操作将永久删除收租记录信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteData(id).then(response => {
          if (response.code == 200) {
            // 操作成功
            this.$message.success('操作成功!')
            this.search(false)
          } else {
            // 操作失败
            this.$message.error(response.data)
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    confirmRecord(data, state) {
      this.confirmLoading = true
      this.$confirm('您是否确认收租?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        data.state = state
        confirmRecord(data).then(response => {
          if (response.code == 200) {
            // 操作成功
            this.$message.success('操作成功!')
            this.search(false)
          } else {
            // 操作失败
            this.$message.error('操作失败!')
          }
          this.confirmLoading = false
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消收租'
        })
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/CollectRecord.vue